import { useState, useCallback } from "react";
import axios from "axios";

// Hook to manage the list of database tables
export const useTableList = () => {
    const [tables, setTables] = useState([]);
    const [loadingTables, setLoadingTables] = useState(false);
    const [tablesError, setTablesError] = useState(null);
    
    // Hidden table names that should not be displayed
    const hiddenTables = ['_cf_KV', 'sqlite_sequence'];
    
    const fetchTables = useCallback(async () => {
        try {
            setLoadingTables(true);
            setTablesError(null);
            
            // Query to get all tables in the database
            const sqlQuery = "SELECT name FROM sqlite_master WHERE type='table' ORDER BY name";
            
            const response = await axios.post("/query", sqlQuery, {
                headers: {
                    "Content-Type": "text/plain",
                    "Authorization": `Bearer ${localStorage.getItem('authToken')}`
                }
            });
            
            if (response.data.isSuccess && response.data.data) {
                // Filter out hidden tables
                const filteredTables = response.data.data.filter(
                    table => !hiddenTables.includes(table.name)
                );
                setTables(filteredTables);
            } else {
                setTablesError("Failed to fetch tables");
            }
        } catch (error) {
            setTablesError(error.response?.data?.message || "Failed to fetch tables");
        } finally {
            setLoadingTables(false);
        }
    }, []);
    
    return {
        tables,
        loadingTables,
        tablesError,
        fetchTables
    };
};